import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-admin-clients',
  templateUrl: './admin-clients.component.html'
})
export class AdminClientsComponent {

  tab = {
    refreshUrl: 'clients/list',
    detailUrl: 'admin/clients',
    detailId: 'id_client',
    cols: [
      { type: 'text', attr: 'name', header: 'Název' },
      { type: 'text', attr: 'ico', header: 'IČO' },
      { type: 'text', attr: 'manager_name', header: 'Manažer' },
      { type: 'text', attr: 'city', header: 'Město' },
      { type: 'text', attr: 'street', header: 'Ulice' }
    ]
  };

  constructor(public shared: SharedService, private router: Router) { }

  addClient(): void {
    this.router.navigate(['/admin/clients/new']);
  }
}
